"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARED_LIST = exports.FAVORITES_LIST_SHARE = exports.DEFAULT_ARIA_LABELS = exports.COPY_LINK_INPUT_WITH_BUTTON = void 0;
const COPY_LINK_INPUT_WITH_BUTTON = exports.COPY_LINK_INPUT_WITH_BUTTON = 'copy-link-input-with-button';
const DEFAULT_ARIA_LABELS = exports.DEFAULT_ARIA_LABELS = {
  copyButton: 'Copy link to clipboard',
  copiedButton: 'Link copied successfully'
};
const FAVORITES_LIST_SHARE = exports.FAVORITES_LIST_SHARE = 'favorites-list-share';
const SHARED_LIST = exports.SHARED_LIST = 'shared-list';
